import { call, put } from "redux-saga/effects";
import { setAddresses, createAddressSuccess, createAddressRequest, createAddressFailure } from "../../entities/address";
import { requestGetAddresses, requestCreateAddress } from "../requests/address";


export function* handleGetAddresses() {
    try {
        const response = yield call(requestGetAddresses);
        if (!response || !response.data) {
            console.error("API odgovor je undefined ili nema podatke");
            return;
        }
        yield put(setAddresses(response.data));
    } catch (error) {
        console.error("Greška prilikom dohvatanja adresa:", error);
    }
}

export function* handleCreateAddress(action) {
    try {
        yield put(createAddressRequest());

        const response = yield call(requestCreateAddress, action.payload);
        if (!response?.data) throw new Error("Nevalidan odgovor sa servera");

        yield put(createAddressSuccess(response.data));
    } catch (error) {
        yield put(createAddressFailure(error.message || "Greška prilikom kreiranja adrese"));
    }
}